import { useStore } from 'zustand';
import { useShallow } from 'zustand/shallow';

import { inventoryStore } from '../InventoryStore';

/**
 * Optimized selector hook for ExperiencesTab component
 * Uses shallow comparison to prevent unnecessary re-renders
 *
 * @returns Selected experience inventory state
 */
export const useExperienceInventoryState = () => {
  return useStore(
    inventoryStore,
    useShallow((state) => ({
      inventoryExperiences: state.inventoryExperiences,
      inventory: state.inventory,
      dependencies: state.dependencies,
      rawInventory: state.rawInventory,
      modifiedInventory: state.modifiedInventory,
      timePeriodStore: state.timePeriodStore,
    }))
  );
};
